export interface CurrencyFormatOptions {
    locale: string
    fractionDigits: number
}

const defaultOptions = {
    locale: "en-US",
    fractionDigits: 2
}

export const currencyOptions: Record<string, CurrencyFormatOptions> = {
    EUR: { locale: "de-DE", fractionDigits: 2 },
    GBP: { locale: "en-GB", fractionDigits: 2 },
    USD: { locale: "en-US", fractionDigits: 2 },
    AUD: { locale: "en-AU", fractionDigits: 2 },
    CAD: { locale: "en-CA", fractionDigits: 2 }
}

/**
 * @deprecated use useCurrencyFormatting hook instead
 */
export function configureCurrency(currency: string, options: CurrencyFormatOptions) {
    currencyOptions[currency] = options
}

/**
 * @deprecated use useCurrencyFormatting hook instead
 * Formats a number as a currency string
 */
export function formatCurrency(value: number, currency: string = "EUR") {
    const { locale, fractionDigits } = currencyOptions[currency] ?? defaultOptions

    const numberFormat = new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    })
    return numberFormat.format(value)
}
